<div class="navbar-desktop-wrapper">
  <mat-toolbar class="navbar-container">
    <div
      *ngIf="this.clientObject.isFullWeb"
      class="navbar-logo"
      (click)="goToHomePage()"
    >
      <img
        *ngIf="clientObject.clientHeaderLogo"
        src="{{ clientObject.clientHeaderLogo }}"
        alt="{{ clientObject.clientName }} logo in desktop"
      />
    </div>
    <div *ngIf="!this.clientObject.isFullWeb" class="navbar-logo">
      <a
        href="{{ this.clientObject.homepageURL }}"
        target="_self"
        rel="noopener noreferrer"
      >
        <img
          *ngIf="clientObject.clientHeaderLogo"
          src="{{ clientObject.clientHeaderLogo }}"
          alt="{{ clientObject.clientName }} logo in desktop"
        />
      </a>
    </div>

    <div class="navbar-menu-container">
      @if (showMainMenu) {

        
        <span *ngFor="let item of clientObject.listOfNavbarItems">
          <a
            [ngClass]="{ active: getRouter(item.link) }"
            *ngIf="item.isInternal && item.link !== '/terms'"
            (click)="
              item.link !== '/about-us'
                ? goToRoute(item)
                : checkForKbAutoRoutes(item)
            "
            target="_self"
            mat-button
          >
            <span>{{ item.url | translate }}</span>
          </a>
          <a
            [ngClass]="{ active: getRouter(item.link) }"
            *ngIf="!item.isInternal && item.link !== '/terms'"
            href=""
            (click)="
              $event.preventDefault(); checkForKbAutoRoutes(item); scrollUp()
            "
            rel="noopener noreferrer"
            target="_blank"
            mat-button
          >
            <span>{{ item.url | translate }}</span>
          </a>
        </span>
      }
      @if (clientObject.isLoginEnabled) { @if (isLoggedIn) {
      <span>
        <a (click)="signOut()" target="_self" mat-button>
          <span>{{ "Sign Out" | translate }}</span>
        </a>
      </span>
      } @else {
      <span>
        <a
          [class]="{ active: getRouter('login') }"
          (click)="signIn()"
          target="_self"
          mat-button
        >
          <span>{{ "Sign in" | translate }}</span>
        </a>
      </span>
      } }
    </div>

    <mat-select
      class="navbar-select-language"
      [(value)]="selectedLanguage"
      panelClass="custom-select-box"
    >
      <mat-option
        #languageOption
        *ngFor="let lang of clientObject.listOfLanguages"
        [value]="lang"
        (click)="useLanguage(lang)"
      >
        <img
          [ngStyle]="{ width: '45px' }"
          src="../../../../assets/images/languages-png/{{
            lang.toString().toUpperCase()
          }}.png"
          alt="language icon"
        />
        <span [ngClass]="{ active: languageOption.selected }">
          {{
            "GENERAL.LANGUAGE." + lang.toString().toUpperCase() | translate
          }}</span
        >
      </mat-option>
    </mat-select>

    <mat-select
      class="navbar-select-currency"
      [(value)]="selectedCurrency"
      panelClass="custom-select-box"
    >
      <mat-option
        #currencyOption
        *ngFor="let currency of clientObject.listOfCurrencies"
        [value]="currency"
        (click)="useCurrency(currency)"
      >
        <img
          [ngStyle]="{ width: '45px' }"
          src="../../../../assets/images/currencies-png/{{
            currency.toString().toUpperCase()
          }}.png"
          class="currency-icon"
          alt="currency icon"
        />
        <span [ngClass]="{ active: currencyOption.selected }">{{
          "GENERAL.CURRENCY." + currency.toString().toUpperCase() | translate
        }}</span>
      </mat-option>
    </mat-select>

    @if (isLoggedIn) {
    <mat-icon class="navbar-user-profile">account_circle</mat-icon>
    }

    <div class="navbar-hamburger-menu">
      <button mat-icon-button aria-label="open menu" (click)="drawer.toggle()">
        <mat-icon class="hamburger-menu-button">menu</mat-icon>
      </button>
    </div>
  </mat-toolbar>
</div>

<div class="navigation-bar-mobile">
  <mat-drawer-container [hasBackdrop]="true">
    <mat-drawer #drawer class="sidenav" mode="over" position="end">
      <mat-icon
        class="sidenav-close-button"
        aria-hidden="false"
        aria-label="close icon"
        (click)="drawer.close()"
      >
        close
      </mat-icon>
      <div class="mobile-navbar-select-language">
        <mat-select
          [(value)]="selectedLanguage"
          panelClass="custom-select-box mobile-select"
        >
          <mat-option
            #languageOptionMobile
            *ngFor="let lang of clientObject.listOfLanguages"
            [value]="lang"
            (click)="useLanguage(lang)"
          >
            <img
              src="../../../../assets/images/languages-png/{{
                lang.toString().toUpperCase()
              }}.png"
              alt="language icon"
            />
            <span>{{
              "GENERAL.LANGUAGE." + lang.toString().toUpperCase() | translate
            }}</span>
          </mat-option>
        </mat-select>
      </div>

      <div class="mobile-navbar-select-currency">
        <mat-select
          class="navbar-select-currency"
          [(value)]="selectedCurrency"
          panelClass="custom-select-box mobile-select"
        >
          <mat-option
            #currencyOptionMobile
            *ngFor="let currency of clientObject.listOfCurrencies"
            [value]="currency"
            (click)="useCurrency(currency)"
          >
            <img
              src="../../../../assets/images/currencies-png/{{
                currency.toString().toUpperCase()
              }}.png"
              class="currency-icon"
              alt="currency icon"
            />
            <span>{{
              "GENERAL.CURRENCY." + currency.toString().toUpperCase()
                | translate
            }}</span>
          </mat-option>
        </mat-select>
      </div>

      <div class="mobile-navbar-menu-items">
        <span *ngFor="let item of clientObject.listOfNavbarItems">
          <a
            *ngIf="item.isInternal"
            [ngClass]="{ active: getRouter(item.link) }"
            (click)="
            $event.preventDefault(); checkForKbAutoRoutes(item); scrollUp(); drawer.close();
          "
            mat-button
          >
            <span>{{ item.url | translate }}</span>
          </a>
          <a
            *ngIf="!item.isInternal"
            [ngClass]="{ active: getRouter(item.link) }"
            href="{{ item.link }}"
            (click)="scrollUp(); drawer.close()"
            rel="noopener noreferrer"
            target="_blank"
            mat-button
          >
            <span>{{ item.url | translate }}</span>
          </a>
        </span>
        @if (clientObject.isLoginEnabled) { @if(!isLoggedIn) {
        <span>
          <a
            [class]="{ active: getRouter('login') }"
            href="{{ loginLink }}"
            (click)="scrollUp(); drawer.close()"
            mat-button
          >
            <span>{{ "Sign in" | translate }}</span>
          </a>
        </span>
        } @else {
        <span>
          <a
            (click)="signOut()"
            (click)="scrollUp(); drawer.close()"
            mat-button
          >
            <span>{{ "Sign out" | translate }}</span>
          </a>
        </span>
        } }
      </div>
    </mat-drawer>
  </mat-drawer-container>
</div>
